export const HowItsWorkPageInformation = {
  step1: {
    title: 'Let’s get started, mate!',
    description:
      'ITAH can plan your whole vacation, business trip and getaway, providing' +
      'you with information on the cheapest transportation means, most' +
      'comfortable and accessible accommodation solutions and a myriad of' +
      'activities during your stay. You decide the budget and the destination ,' +
      'or just let ITAH surprise you with new horizons and attractions.',
  },
  step2: {
    title: 'Fill out ITAH’s questionnaire',
    description:
      'ITAH prepared a short and fun questionnaire for you to understand your' +
      'preferences and resources for a particular trip. Take a couple of minutes' +
      'to fill it out, and your job is done! If you want to keep an open mind' +
      'and get spontaneous destination offers, that also works for us!',
  },
  step3: {
    title: 'Wait for your personalized packages!',
    description:
      'Once you submit the questionnaire, ITAH will generate multiple individual' +
      'package offers for you based on the budget and preferences you mentioned' +
      'in the short survey! A journey of a thousand miles must begin with a' +
      'single step. (Lao Tzu)',
  },
};
